// extracted by mini-css-extract-plugin
export var borderRadius = "_fx-4";
export var large = "_fx-3";
export var logoContainer = "_fx-0";
export var nameLogo = "_fx-2";
export var small = "_fx-1";